import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Profile = Loadable(lazy(() => import('./Profile')));
const ProfileSection = Loadable(lazy(() => import('./ProfileSection')));
const ChangePassword = Loadable(lazy(() => import('./ChangePassword')));
const Manage = Loadable(lazy(() => import('./Manage')));
const Feedback = Loadable(lazy(() => import('./Feedback')));
const DeveloperRequest = Loadable(lazy(() => import('./DeveloperRequest')));
const DownloadCenter = Loadable(lazy(() => import('./DownloadCenter')));
const InspectionReport = Loadable(lazy(() => import('./Inspection')));

const ProfileRoutes = [
	{
		path: '/dashboard/profile',
		element: <Profile />,
		auth: authRoles.admin,
	},
	{
		path: '/add/staff',
		element: <ProfileSection />,
		auth: authRoles.admin,
	},
	{
		path: '/dashboard/changepassword',
		element: <ChangePassword />,
		auth: authRoles.admin,
	},
	{
		path: '/manage/markup',
		element: <Manage />,
		auth: authRoles.admin,
	},
	{
		path: '/feedback',
		element: <Feedback />,
		auth: authRoles.admin,
	},
	{
		path: '/developerrequest',
		element: <DeveloperRequest />,
		auth: authRoles.admin,
	},
	{
		path: '/downloadcenter',
		element: <DownloadCenter />,
		auth: authRoles.admin,
	},
	{
		path: '/inspectionreport',
		element: <InspectionReport />,
		auth: authRoles.admin,
	},
];

export default ProfileRoutes;
